/**
 * Profile Service
 * API operations for account management (email/password changes via Gateway)
 */
import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '@/constants/api';

export const profileService = {
  /**
   * Change email address (requires current password verification)
   */
  updateEmail: (data: { newEmail: string; currentPassword: string }) =>
    apiClient.patch<{ email: string }>(API_ENDPOINTS.ACCOUNT.EMAIL, data),

  /**
   * Change password (requires current password verification)
   */
  updatePassword: (data: { currentPassword: string; newPassword: string }) =>
    apiClient.patch<{ message: string }>(API_ENDPOINTS.ACCOUNT.PASSWORD, data),
};
